import React, { Component } from 'react';
import Loading from './Loading';
import {_Alert, _getToken, _post, _isLogin, variable} from "./Function";
import '../css/PaymentList.css'

class PaymentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year_value : this.props.match.params.year,
            loadingShow: true,
            data : [],
            yearList: [],
            list : [],
            keeping: [],
            keep_month: '',
            keep_year: '',
            keep_txt_total: '',
            keep_total: '',
            member : {},
            is_keep: false,
            is_year : false,
            is_list: false
        };

        _isLogin().then( value => {
            if(value) {
                this.getBillYear();
                // this.getBillMonth();
                this.getChargeBack();
                this.getMember()
            }
        })
        setTimeout(()=>{ this.setState({ year_value :  this.props.match.params.year }); }, 500)
    }

    getBillYear(){
        let param = {token: _getToken(), platform: variable().platform};
        _post('get.bill.year.php', param)
            .then(res => {
                // console.log('res', res)
                if (res.data.responseText === 101) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                }
                this.setState({
                    loadingShow: false,
                    data: res.data.data,
                    is_year: (res.data.status === 1),
                    year_value : res.data.data[0].year
                });
                this.getBillMonth()
                console.log('state Year ', this.state)
            }).catch((err) => {
                this.setState({loadingShow: false});
                //_Alert('error');
            });
    }

    getChargeBack() {
        let params = {
            token: _getToken(),
            platform: variable().platform,
            month: new Date().getMonth(),
            year: new Date().getFullYear()
        }
        _post('get.chargback.php', params).then((res) => {
            // console.log("chargback : ",res)
            if (res.data.responseText === 101) {
                localStorage.clear();
                _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
            }
            this.setState({
                loadingShow: false,
                keeping: res.data.data,
                keep_month: res.data.month,
                keep_year: res.data.year,
                keep_txt_total: res.data.txt_total,
                keep_total: res.data.total,
                is_keep: (res.data.status !== 0),
                year_value: res.data.data[0].year
            });

        }).catch((err) => {
            this.setState({
                loadingShow : false,
            })
            //_Alert("error")
        })
    }

    getBillMonth(){
        const {year_value} = this.state
        let param
        if(year_value) {
             param = {token: _getToken(), platform: variable().platform, year: year_value};
        }else{
             param = {token: _getToken(), platform: variable().platform};
        }
        _post('get.bill.month.php', param).then( res => {
            this.setState({
                loadingShow: false,
                list : res.data.data,
                is_list : (res.data.status === 1)
            })
        })

        console.log("_parm >> ",this.state)
    }

    getMember(){
        let params = {token: _getToken(), platform: variable().platform};
        _post('web.dashboard.php', params).then( res => {
            this.setState({
                loadingShow : false,
                member: res.data.data,
                is_member : (res.data.status === 1)
            })
        }).catch( err => {
            this.setState({
                loadingShow: false
            })
        })
    }

    onHandleSelectYear = (event) => {
        console.log("select year :", event.target.value);
        this.setState({year_value : event.target.value })
        window.location.href = variable().BASE_URL + "/online/payment/"+event.target.value;
    }



    getBillOption = () =>{
        const {data} = this.state;
        return (
            <select className="form-control" onChange={(e) => { this.onHandleSelectYear(e) }} value={this.state.year_value}>
                { data.map(data => (
                    <option value={data.year}>{data.year}</option>
                ))}
            </select>
        )
    }

    getHeaderBills = () => {
        return (
            <div className="flex-card-header">
                <div>เดือน</div>
                <div className="">
                    <label><span>ปี : </span>{this.getBillOption()}</label>
                </div>
            </div>
        )
    }

    goToLBill = (bill_no) => {
        const { year_value } = this.state;
        let year = this.state.data[0].year;
        console.log("selected year : "+year_value, "year : "+this.state.data[0].year);
        if(typeof year_value !== "undefined"){
            year = year_value
        }
        window.location.href = variable().BASE_URL + "/online/payment/month/" + bill_no+"/"+year;

    }

    keepingMonth = () => {
        const {keeping, keep_month, keep_year, keep_txt_total, keep_total, member } = this.state
        return (
            <div>
                <div>
                    <span className="title">รายการเรียกเก็บประจำเดือน {keep_month} {keep_year}</span>
                </div>
                <div className="flex-container">
                    <div className="flex-card">
                        <div>วันที่ :</div>
                        <div className="text-right">{keep_month} { keep_year}</div>
                    </div>
                    <div className="flex-card">
                        <div>รหัสสมาชิก : </div>
                        <div className="text-right">{member.member_id}</div>
                    </div>
                </div>
                <div className="flex-container">
                    <div className="flex-card">
                        <div>ชื่อ-สกุล :</div>
                        <div className="text-right">{member.member_name}</div>
                    </div>
                    <div className="flex-card">
                        <div>สังกัด :</div>
                        <div className="text-right">{member.affiliation} </div>
                    </div>
                </div>
                <div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="text-center">รายการชำระ</th>
                                <th className="text-center">งวดที่</th>
                                <th className="text-center">ยอดเงิน</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                keeping.map( keep => (
                                    <tr>
                                        <td>{keep.deduct_detail}</td>
                                        <td className="text-center">{ (keep.period) ? keep.period : '-' }</td>
                                        <td className="text-right">{keep.pay_amount}</td>
                                    </tr>
                                ))
                            }
                            <tr>
                                <td colSpan="2">( {keep_txt_total} )</td>
                                <td className="text-right"><span style={{ marginRight: 20+"px" }}>รวมเป็นเงิน</span> {keep_total}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }


    billListMonth = () =>{
        return (
            <div className="table-responsive">
                <table className="table">
                    <tbody>
                    {
                        this.state.list.map(list => (
                            <tr onClick={(e) => { this.goToLBill(list.month_id)}}>
                                <td>{list.month}</td>
                                <td style={{textAlign: 'right'}}>
                                    <i className="fas fa-arrow-alt-circle-right"></i>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        console.log('state is_list : ' , this.state.is_list)
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-calendar-alt"></i></div>
                            <div className="card-title-text">รายการเรียกเก็บ</div>
                        </div>
                        <div className="card-content">
                            { (this.state.is_keep ) ? this.keepingMonth() : <div className="no-data">ไม่พบรายการเรียกเก็บ</div> }
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-print"></i></div>
                            <div className="card-title-text">ใบเสร็จ</div>
                        </div>
                        <div className="card-content">
                            { (this.state.is_list) ? this.getHeaderBills() : '' }
                            { (this.state.is_list) ? this.billListMonth() : <div className="no-data">ไม่พบใบเสร็จ</div> }
                        </div>
                    </div>
            </div>
        );
    }
}

export default PaymentList;
